import clsx from 'clsx'
import Text from '../Common/NewText'

export default function Heatbar({
  leftValue,
  rightValue,
  leftPercentage,
  title,
  arrowValue,
  leftLimitText,
  rightLimitText,
}: {
  leftValue?: string
  rightValue?: string
  leftPercentage?: number
  title?: string
  arrowValue?: string
  leftLimitText?: string
  rightLimitText?: string
}) {
  const arrowLeftStyle = `calc(${leftPercentage}% - ${
    (leftPercentage ?? 0) >= 50 ? 20 : 4
  }px)`

  return (
    <div
      className={clsx('flex w-full flex-col items-center justify-center', {
        'pb-5': arrowValue,
      })}
    >
      <div className="flex w-full items-center justify-between">
        <div className="flex text-xs font-medium md:text-sm">
          {leftLimitText && (
            <span className="mr-1 font-normal">{leftLimitText}:</span>
          )}
          {leftValue}
        </div>
        {title && (
          <Text className="text-grey hidden text-center text-sm font-normal lg:block">
            {title}
          </Text>
        )}
        <div className="flex text-xs font-medium md:text-sm">
          {rightLimitText && (
            <span className="mr-1 font-normal">{rightLimitText}:</span>
          )}
          {rightValue}
        </div>
      </div>
      <div className="from-brand-tango to-brand-green-dark flex h-1 w-full rounded-lg bg-gradient-to-r" />
      <div className="relative w-full">
        <div
          className="absolute w-4 overflow-hidden"
          style={{ left: arrowLeftStyle }}
        >
          <div className=" h-2 w-2 origin-bottom-left rotate-45 transform bg-black" />
        </div>

        {arrowValue && (
          <div
            className="text-grey absolute -bottom-6 hidden -translate-x-3 transform text-sm md:block"
            style={{
              left: arrowLeftStyle,
            }}
          >
            {arrowValue}
          </div>
        )}
      </div>
    </div>
  )
}
